import { useState, useEffect, useRef } from 'react';
import { safeJsonParse } from '../libs/lib';

const url = process.env.REACT_APP_WSS;

const isTopicInvolved = (topicsSubscribed, topicPublished) => {
  if (Array.isArray(topicsSubscribed)) {
    return topicsSubscribed.includes(topicPublished);
  }
  return topicsSubscribed === topicPublished;
};

/**
 * Custom hook to manage a native WebSocket connection
 * @param {object} props
 * @param {string | [string]} props.topics - Topics to subscribe on, string for single topic or array of string for multi topics
 * @param {(data: object | any) => void} props.handleOnMessage - Callback function whenever message received from server
 * @returns {Object} { messages, isConnected, sendMessage, lastMessage, error }
 */
export function useWebSocket({
  topics,
  handleOnMessage,
}) {
  // const [messages, setMessages] = useState([]);
  // const [lastMessage, setLastMessage] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [error, setError] = useState(null);

  const socketRef = useRef(null);
  // Keep a ref that always points to the latest handleOnMessage function
  const savedHandler = useRef(handleOnMessage);

  useEffect(() => {
    savedHandler.current = handleOnMessage;
  }, [handleOnMessage]);

  useEffect(() => {
    if (!url || !topics) return;

    // Initialize WebSocket instance
    const socket = new WebSocket(url);
    socketRef.current = socket;

    socket.onopen = () => {
      console.log('Connected to WebSocket server');
      sendMessage({
        type: 'subscribe',
        topics,
      })
      console.log(`Subscribed to: `, topics);
      setIsConnected(true);
      setError(null);
    };

    socket.onmessage = (event) => {
      // setLastMessage(event.data);
      // setMessages((prev) => [...prev, event.data]);

      console.log(`Message data received: `, event.data);
      if (savedHandler.current) {
        const data = safeJsonParse(event.data);
        if (data.type === 'topic' && isTopicInvolved(topics, data.topic)) {
          savedHandler.current(data);
        }
      }
    };

    socket.onerror = (err) => {
      console.error('WebSocket error:', err);
      setError(err);
    };

    socket.onclose = () => {
      console.log('Disconnected from WebSocket server');
      setIsConnected(false);
    };

    // Cleanup on unmount or URL change
    return () => {
      socket.close();
    };
  }, []);

  // Send message to server
  const sendMessage = (data) => {
    if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
      const payload = typeof data === 'object' ? JSON.stringify(data) : data;
      socketRef.current.send(payload);
      return true;
    } else {
      console.warn('WebSocket is not connected.');
      return false;
    }
  };

  return {
    // messages,
    // lastMessage,
    isConnected,
    error,
    sendMessage,
  };
}